import { Link } from "wouter";
import { trpc } from "../lib/trpc";
import { Stat, Card, Badge, Spinner } from "../components/ui";
import { timeAgo, fmtNum, fmtDateTime } from "../lib/format";
import { FlowLabel } from "./Reconcile";

export default function Dashboard() {
  const sync = trpc.pbs.syncStatus.useQuery();
  const snaps = trpc.snapshots.status.useQuery();
  const sets = trpc.reconcile.changeSets.useQuery({ limit: 6 });

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold">Dashboard</h1>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <Stat accent="indigo" label="PBS products" value={fmtNum(sync.data?.products)} sub={`Last sync ${timeAgo(sync.data?.lastJob?.completedAt)}`} />
        <Stat label="Categories" value={fmtNum(sync.data?.categories)} />
        <Stat accent="green" label="ExactOnline items" value={fmtNum(snaps.data?.exact.total)} sub={`${fmtNum(snaps.data?.exact.active)} active · ${timeAgo(snaps.data?.exact.fetchedAt)}`} />
        <Stat accent="amber" label="Lightspeed variants" value={fmtNum(snaps.data?.lightspeed.total)} sub={`Updated ${timeAgo(snaps.data?.lightspeed.fetchedAt)}`} />
      </div>

      <Card title="Recent change sets" actions={<Link href="/reconcile" className="text-sm text-blue-600">View all →</Link>}>
        {sets.isLoading ? (
          <Spinner />
        ) : !sets.data?.length ? (
          <p className="text-sm text-slate-500">No change sets yet. Run a reconciliation from the Reconcile page.</p>
        ) : (
          <table className="w-full text-left text-sm">
            <thead className="text-xs uppercase tracking-wide text-slate-500">
              <tr><th className="py-2">ID</th><th>Flow</th><th>Summary</th><th>Status</th><th>When</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {sets.data.map((cs) => {
                const s = cs.summary as { total?: number; create?: number; update?: number } | null;
                return (
                  <tr key={cs.id}>
                    <td className="py-2"><Link href={`/reconcile/${cs.id}`} className="font-medium text-blue-600">#{cs.id}</Link></td>
                    <td><FlowLabel target={cs.target} /></td>
                    <td className="text-slate-600">{s?.total ?? 0} ops ({s?.create ?? 0} create, {s?.update ?? 0} update)</td>
                    <td><Badge color={cs.status === "applied" ? "green" : cs.status === "pending_approval" ? "amber" : cs.status.includes("fail") ? "red" : "gray"}>{cs.status}</Badge>{cs.dryRun && <span className="ml-1"><Badge color="blue">dry-run</Badge></span>}</td>
                    <td className="text-slate-500">{fmtDateTime(cs.createdAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
